module.exports = __webpack_public_path__ + "files/7fc56d45ab1eeeb2d15b97c5679fb5e3.png";